"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInteger = exports.is32bitInteger = void 0;
const is32bitInteger = (value) => {
    return value < Math.pow(2, 31) - 1 && value > -Math.pow(2, 31) + 1;
};
exports.is32bitInteger = is32bitInteger;
// Avoid weird values like 251 = 250.99999999999997
const getInteger = (value) => {
    return parseInt(value.toFixed());
};
exports.getInteger = getInteger;
